/* global angular, moment */
/**
 * Created by lari on 04/05/2017.
 */
(function () {
  'use strict';
  angular.module('vcclient')
    .component('riskedit', {
      restrict: 'E',
      bindings: {
        risk: '=',
        parentsave: '&'
      },
      templateUrl: 'vcclient/riskedit-component.tpl.html',
      controllerAs: 'vm',
      controller: ['$log',
        function ($log) {
          let vm = this;
          vm.save = save;
          vm.childsave = childsave;


          vm.$onInit = function () {
            // $log.debug('***** debug: risk: ', vm.risk);
            vm.lastrisk = angular.copy(vm.risk);
          };

          function childsave(key, value) {
            vm.risk[key] = value;
            vm.save();
          }


          function save() {
            $log.debug('debug: riskeditedit save called');
            if (!angular.equals(vm.risk, vm.lastrisk)) {
              vm.lastrisk = angular.copy(vm.risk);
              $log.debug('debug: contactedit calling parentsave');
              vm.parentsave();
            }
          }


        }] // controller
    }); // component

// klammerfriedhof
}());